var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseFont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.829 7.214V6.143H9.756a.648.648 0 01-.643-.643c0-.352.292-.643.643-.643h1.072V3.785c0-.351.291-.642.642-.642.352 0 .643.291.643.642v1.072h1.072c.351 0 .643.291.643.643a.648.648 0 01-.643.643h-1.072v1.071a.648.648 0 01-.643.643.648.648 0 01-.643-.643zM4.063 0h2.088l4.063 11H7.966l-.932-2.787H3.051L2.12 11H0L4.063 0zm2.393 6.498L5.043 2.226l-1.43 4.272h2.843z",
    fill: "#499D71"
  })));
}
export default SvgIncreaseFont;